import { render, staticRenderFns } from "./NoCampaign.vue?vue&type=template&id=b2938b3a&scoped=true"
import script from "./NoCampaign.vue?vue&type=script&lang=js"
export * from "./NoCampaign.vue?vue&type=script&lang=js"
import style0 from "./NoCampaign.vue?vue&type=style&index=0&id=b2938b3a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2938b3a",
  null
  
)

export default component.exports